<template>
  <div >
    <!-- <div class="top">
      <div class="logo"></div>
      <p>促进软件开发领域知识与创新的传播</p>
    </div> -->
    <div class="copyright">
      Copyright © {{(new Date()).getFullYear()}}, Geekbang Technology Ltd. All rights reserved. 极客邦控股（北京）有限公司<br />
      <a href="http://www.beian.miit.gov.cn" target="_blank"><span style="color:#D1D6E1;">京 ICP 备 16027448 号 - 5</span></a>
      <div style="width:300px;margin:0 auto; padding:20px 0 10px;">
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502039052" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
          <img src="../../../assets/img/beian.png" style="float:left;" alt="京公网安备" />
          <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#D1D6E1;">京公网安备 11010502039052号</p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footer-wap',
  components: {
  },
  props: {},
  data () {
    return {
    }
  },
  computed: {
  },
  created () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/common';
  .top {
    padding: 37px 0 40px;
    background:#FFF;
    border-top: 1px solid $borderGray;

    & .logo {
      width:100%; height: 27px;
      background:url('../../../assets/img/logo.png') no-repeat center center;
      background-size: 92px 27px;
    }
    & p{
      padding-top: 7px;
      text-align: center;
      @include lineFont(14, 400);
      color: #888888;
    }
  }
  .copyright {
    box-sizing: border-box;
    width: 100%;
    padding: 24px 20px;
    background: #646D7D;
    text-align: center;
    @include lineFont(12, 400);
    line-height: 18px;
    color: #D1D6E1;
  }
  @media screen and (max-width: 414px) {
    .copyright {
      padding: 24px 40px;
    }
  }
  @media screen and (max-width: 375px) {
    .copyright {
      padding: 24px 22px;
    }
  }
</style>
